import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Globals} from '../../../global/global.model';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';


@Injectable()
export class FotoTecnicosServices {

	constructor(private http: HttpClient) { }

	saveFotoTecnico(data:any){
		return this.http.post(Globals.BASE_URL_API_REST+'fototecnicos.json',data);
	}

	deleteFotoTecnico(id:number){
		return this.http.delete(Globals.BASE_URL_API_REST+'fototecnicos/'+id+'.json');
	}


}